import { FC } from 'react'

import styled from 'styled-components'
import { useNavigate } from 'react-router-dom'

import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { ArtistRoutesEnum } from 'src/Router/ArtistComponentsNewUI'
import { useAppDispatch, useAppSelector } from 'src/Hooks/redux'
import { PrimaryAlert } from 'src/Components/PrimaryAlert'
import { PrimaryDottedButton } from 'src/Components/Buttons/PrimaryDottedButton'
import { getCampaigns } from 'src/Redux/campaignList-process'
import {
  getApprovedAlertsIds,
  setApprovedAlertsList,
} from 'src/Redux/alert-process'

const StyledPrimaryDottedButton = styled(PrimaryDottedButton)`
  padding-left: 0;
  padding-right: 0;
`
const GreenPrimaryDottedButtonWrapper = styled.div`
  display: flex;
  gap: 16px;
`

const APPROVED_STATUSES = ['pending', 'approved']

export const CampaignApprovedAlert: FC = () => {
  const dispatch = useAppDispatch()
  const navigate = useNavigate()

  const campaigns = useAppSelector(getCampaigns)
  const approvedIdsAlertArray = useAppSelector(getApprovedAlertsIds)

  const campaign = campaigns?.find(
    ({ status, id }) =>
      APPROVED_STATUSES.includes(status) &&
      !approvedIdsAlertArray.includes(Number(id)),
  )

  const onLaunchCampaign = (): void => {
    if (!campaign?.id) {
      return
    }
    const updatedAlertIds = [...approvedIdsAlertArray, Number(campaign.id)]
    dispatch(setApprovedAlertsList(updatedAlertIds))
    if (campaign.platformType === CampaignPlatformTypeEnum.SPOTIFY) {
      navigate(`${ArtistRoutesEnum.SpotifySchedule}/${campaign?.id}`)
    } else if (campaign.platformType === CampaignPlatformTypeEnum.META) {
      navigate(`${ArtistRoutesEnum.AdsSchedule}/${campaign?.id}`)
    } else {
      navigate(`${ArtistRoutesEnum.TiktokSchedule}/${campaign?.id}`)
    }
  }

  if (!campaign) {
    return null
  }

  return (
    <PrimaryAlert
      type='success'
      hasCross={false}
      title='Your campaign is approved!'
      renderButtons={() => (
        <GreenPrimaryDottedButtonWrapper>
          <StyledPrimaryDottedButton onClick={onLaunchCampaign}>
            Start campaign
          </StyledPrimaryDottedButton>
        </GreenPrimaryDottedButtonWrapper>
      )}
    >
      Great news! Your campaign for {campaign?.trackTitle} has been approved.
      Take this opportunity to reach more fans and keep the momentum going.
      Click the button below to start your campaign now.
    </PrimaryAlert>
  )
}
